module.exports = __webpack_public_path__ + "img/hu.2c5d14ab.svg";